export default __webpack_public_path__ + "static/media/leader-3.7cd0de52.webp";